export default __webpack_public_path__ + "static/desk04-dd6297acb27cdf6b31b7598d734e41db.png";